import styled, { CSSProperties } from 'styled-components';
import pick from 'lodash/pick';

import { ElementOf } from 'types/utilityTypes';

import { getBaseUnit } from '../styles/themeGetters';
import {
  marginMixin,
  MarginProps,
  paddingMixin,
  PaddingProps,
} from '../utils/mixins';

const FLEX_CONTAINER_PROPS = [
  'alignItems',
  'alignContent',
  'justifyContent',
  'justifyItems',
  'flexWrap',
  'rowGap',
  'columnGap',
  'placeContent',
  'placeItems',
] as const;

type FlexContainerProps = Partial<
  Pick<CSSProperties, ElementOf<typeof FLEX_CONTAINER_PROPS>>
>;

type Props = {
  gap?: number;
  col?: boolean;
  fullWidth?: boolean;
  height?: number;
} & FlexContainerProps &
  MarginProps &
  PaddingProps;

export const Flex = styled.div<Props>`
  display: flex;
  gap: ${({ gap }) => gap && getBaseUnit(gap)};
  flex-direction: ${({ col }) => (col ? 'column' : 'row')};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  height: ${({ height }) => height && getBaseUnit(height)};

  ${props => pick(props, FLEX_CONTAINER_PROPS)}

  ${marginMixin}
  ${paddingMixin}
`;
